import { Body } from "@components/v2/typography/body";
import { Headline } from "@components/v2/typography/headline";

type ScheduledExportHeaderProps = {
  title: string;
  description?: string;
};

export const ScheduledExportHeader = ({
  title,
  description,
}: ScheduledExportHeaderProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Headline variant={500}>{title}</Headline>
      {description && (
        <Body variant={200} color="secondary" fontWeight="medium">
          {description}
        </Body>
      )}
    </div>
  );
};
